export const CONTRACT_COLUMN_NAME = {
  Area: 'area',
  Building: 'building',
  Category: 'category',
  ContractEnd: 'end_date',
  ContractId: 'contract_id',
  ContractStart: 'start_date',
  DelayedDate: 'delayed_date',
  Duration: 'duration',
  Dwellers: 'dwellers',
  EntranceAddress: 'entrance_address',
  Flat: 'flat',
  Floor: 'floor',
  HeatType: 'heat_type',
  Inhabitant: 'inhabitant',
  InhabitantRole: 'inhabitant_role',
  InhabitantStatus: 'inhabitant_status',
  Landlords: 'landlords',
  LiveArea: 'live_area',
  PropertyShare: 'property_share',
  RoomCount: 'room_count',
  SecondContractId: 'purchase_contract_number',
}

// The backend table config names flat-attribute columns with a `flat_` prefix,
// while list items expose the same data under the bare field names.
export const CONTRACT_FIELD_BY_COLUMN_NAME = {
  flat_area: CONTRACT_COLUMN_NAME.Area,
  flat_category: CONTRACT_COLUMN_NAME.Category,
  flat_dwellers: CONTRACT_COLUMN_NAME.Dwellers,
  flat_entrance_address: CONTRACT_COLUMN_NAME.EntranceAddress,
  flat_floor: CONTRACT_COLUMN_NAME.Floor,
  flat_heat_type: CONTRACT_COLUMN_NAME.HeatType,
  flat_landlords: CONTRACT_COLUMN_NAME.Landlords,
  flat_live_area: CONTRACT_COLUMN_NAME.LiveArea,
  flat_property_share: CONTRACT_COLUMN_NAME.PropertyShare,
  flat_room_count: CONTRACT_COLUMN_NAME.RoomCount,
}
